import { render } from "./QAForm.vue?vue&type=template&id=ef15326e"
import script from "./QAForm.vue?vue&type=script&lang=js"
export * from "./QAForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__